import globalStyles from '../App.module.scss';

export default function TermsLink() {
    return (
        <div>
            <p className={globalStyles.smallInfoText}>
                Ved å melde deg inn aksepterer du{' '}
                <a href="https://www.skiforeningen.no/nettbutikk/vilkar/" target="_blank" rel="noreferrer noopener">
                    Skiforeningens vilkår for kjøp av medlemskap
                </a>
                .
            </p>
        </div>
    );
}
